
export function getColorfromCssVar(cssVarName:string): string {
    return getComputedStyle(document.body)?.getPropertyValue('--'+cssVarName);
}
